import { render, staticRenderFns } from "./StockKittingStateHistory.vue?vue&type=template&id=2c0b2a04&scoped=true&"
import script from "./StockKittingStateHistory.vue?vue&type=script&lang=js&"
export * from "./StockKittingStateHistory.vue?vue&type=script&lang=js&"
import style0 from "./StockKittingStateHistory.vue?vue&type=style&index=0&id=2c0b2a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b2a04",
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
